
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import qs from 'qs';

import fetchCommonInfo from '@/utils/commonConfig';

interface ConfigRes {
  code?: number,
  data?: any,
}

const LANG_MAPPER = {
  zh: '',
  'zh-TW': 'Tw',
  en: 'En',
};

@Component({
  name: 'QdSign',
})
class QdSign extends Vue {
  @Prop() type: any;
  @Prop({ type: String, default: '{}' }) wpaDetail;

  // @InjectReactive('wpaDetail') wpaDetail: any;

  show: number = 0;
  supportInfo: any;
  name: string = '';
  logo: string = '';
  website: string = '';

  get isMobile() {
    return 'pc' !== this.type;
  }

  @Watch('$i18n.locale')
  onLangChanged() {
    this.handleSupport();
  }

  @Watch('wpaDetail')
  onWpaDetailChange(value) {
    this.fetchConfig(JSON.parse(value));
  }

  created() {
    this.fetchConfig(JSON.parse(this.wpaDetail));
  }

  fetchConfig(wpaDetail: any): void {
    const { kfuin, wpaId, key, fid } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    const body = {
      kfuin: kfuin || wpaDetail.kfuin,
      wpaId: (this.isMobile ? fid : wpaId) || wpaDetail.wpaId,
      key: key || wpaDetail.key,
      fields: ['tools', 'supportInfo'],
    };
    fetchCommonInfo(
      body,
      ({ supportInfo = {}, tools = {} }: { supportInfo: ConfigRes, tools: ConfigRes }) => {
        const { code: codeS, data: dataS } = supportInfo;
        const { code: codeT, data: dataT } = tools;
        if (0 === codeS && 0 === codeT) {
          this.supportInfo = dataS;
          this.show = dataT?.isShowQidianSign;
          this.logo = dataS?.suportLogo;
          this.handleSupport();
        }
      },
    );
  }

  handleSupport(): void {
    if (!this.supportInfo) return;
    const lang = this.$i18n.locale;
    const suffix = LANG_MAPPER[lang];
    this.name = this.supportInfo[`suportName${suffix}`];
    this.website = this.supportInfo[`suportWebsite${suffix}`] || this.supportInfo.suportWebsite;
  }
}

export default QdSign;
